export default __webpack_public_path__ + "static/media/Notifications.96ce36db.svg";